import { LOCATE_RECEIVED_AUTH_TOKEN, LOCATE_SUCCEEDED, LOCATE_FAILED } from './actions'
const initialState = {
    authToken: null,
    authorizedCollectionId: null,
    failureReason: null
};

export default function(locate=initialState, action) {
    switch (action.type) {
        case LOCATE_RECEIVED_AUTH_TOKEN:
            return {
                ...locate,
                authToken: action.authToken,
                emailedTo: action.emailedTo
            };
        case LOCATE_SUCCEEDED:
            return {
                ...locate,
                authorizedCollectionId: action.collectionId
            };
        case LOCATE_FAILED:
            return {
                ...locate,
                failureReason: action.failureReason
            };
        default:
            return locate;
    }
}